// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.green-flag_green-flag_YzYwH {
    width: 2rem;
    height: 2rem;
    padding: 0.375rem;
    border-radius: 0.25rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    user-drag: none;
    cursor: pointer;
}

.green-flag_green-flag_YzYwH:hover {
    background-color: var(--looks-light-transparent);
}

.green-flag_green-flag_YzYwH.green-flag_is-active_Kh7At {
    background-color: var(--looks-transparent);
}
`, "",{"version":3,"sources":["webpack://./src/components/green-flag/green-flag.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,0CAA0C;AAC9C","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.green-flag {\n    width: 2rem;\n    height: 2rem;\n    padding: 0.375rem;\n    border-radius: 0.25rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    user-drag: none;\n    cursor: pointer;\n}\n\n.green-flag:hover {\n    background-color: var(--looks-light-transparent);\n}\n\n.green-flag.is-active {\n    background-color: var(--looks-transparent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"green-flag": `green-flag_green-flag_YzYwH`,
	"greenFlag": `green-flag_green-flag_YzYwH`,
	"is-active": `green-flag_is-active_Kh7At`,
	"isActive": `green-flag_is-active_Kh7At`
};
export default ___CSS_LOADER_EXPORT___;
